import { AppBar, Button, IconButton, ListItemIcon, Menu, MenuItem, Toolbar } from "@material-ui/core";

import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { Fragment } from "react";
import MeditocCambiarPass from "./MeditocCambiarPass";
import MenuIcon from "@material-ui/icons/Menu";
import PersonIcon from "@material-ui/icons/Person";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import { imgLogoMeditoc } from "../../settings/imgConfig";
import { useLayout } from "../../context/LayoutContext";
import { useLogin } from "../../context/LoginContext";
import { useStyle } from "../../context/StyleContext";

export default function MeditocNavBar() {
    const { classes } = useStyle();
    const { isMenuOpen, anchorEl, handleClickUserMenu, handleCloseUserMenu, handleOpenMenu } = useLayout();
    const { usuarioSesion, handleClickCambiarPassword, handleClickSignOff } = useLogin();

    return (
        <Fragment>
            <div className="flx-grw-1">
                <AppBar position="relative" color="inherit" elevation={0}>
                    <Toolbar>
                        <IconButton className="size-50" onClick={handleOpenMenu(true)}>
                            <MenuIcon className="color-1" />
                        </IconButton>
                        <div className="flx-grw-1">
                            <img className="navbar-img" src={imgLogoMeditoc} alt="logomeditoc" />
                        </div>
                        <PersonIcon className="color-1" />
                        <Button style={{ textTransform: "initial" }} onClick={handleClickUserMenu}>
                            <span className="rob-con bold color-1 size-20">
                                {usuarioSesion.sNombres + " " + usuarioSesion.sApellidoPaterno}
                            </span>
                        </Button>
                        <Menu
                            anchorEl={anchorEl}
                            id="menu-profile"
                            keepMounted
                            open={isMenuOpen}
                            onClose={handleCloseUserMenu}
                            classes={{ paper: classes.rootNavBar }}
                        >
                            <MenuItem onClick={handleClickCambiarPassword}>
                                <ListItemIcon>
                                    <VpnKeyIcon className="color-0" />
                                </ListItemIcon>
                                Cambiar contraseña
                            </MenuItem>
                            <MenuItem onClick={handleClickSignOff}>
                                <ListItemIcon>
                                    <ExitToAppIcon className="color-0" />
                                </ListItemIcon>
                                Cerrar sesión
                            </MenuItem>
                        </Menu>
                    </Toolbar>
                </AppBar>
            </div>
            <MeditocCambiarPass />
        </Fragment>
    );
}
